import React from 'react';
import Title from '../Title';
import ServiceCard from '../Services/ServiceCard';
import { useTranslation } from 'react-i18next';

const ServiceSection = () => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col p-6 md:p-12 gap-6 md:gap-12'>
      <Title>{t('services.services_title')}</Title>
      <ServiceCard />
    </div>
  );
};

export default ServiceSection;